    import { ArrowLeftOutlined } from "@ant-design/icons";
    import usePDASidebarStore from "src/store/pda/usePDASidebarStore";
    import usePDAResetStore from "src/store/pda/usePDAResetStore";
    import { MenuDto } from "src/dtos/menu/menuDto";
    import PDASidebar from "./Sidebar";

    interface PDAHeaderProps {
    menuNm: string;
    menuCd?: string;
    onBack?: () => void;
    onMenuClick?: (menu: MenuDto) => void;
    }

    /**
     * PDA 화면 공통 헤더 컴포넌트
     * 
     * @param menuNm - 메뉴명 (필수)
     * @param menuCd - 메뉴 코드 (선택사항, 표시용)
     * @param onBack - 뒤로가기 버튼 클릭 핸들러
     */
    const PDAHeader = ({ menuNm, menuCd, onBack, onMenuClick }: PDAHeaderProps) => {
    const { toggleSidebar, isOpen, closeSidebar } = usePDASidebarStore();
    const { resetAll } = usePDAResetStore();

    // 뒤로가기 핸들러 (상태 초기화 포함)
    const handleBackClick = () => {
        // 모든 등록된 reset 함수 실행
        resetAll();
        // 원래 onBack 핸들러 실행
        if (onBack) {
            onBack();
        }
    };

    return (
        <>
        <div className="w-full bg-blue-dark text-white px-4 py-1 flex items-center justify-between ">
        {onBack && (
            <button onClick={handleBackClick} className="mr-2">
            <ArrowLeftOutlined className="text-xl" />
            </button>
        )}
        <h1 className="text-lg font-medium flex-1">
            {menuNm} / {menuCd}
        </h1>
        <button onClick={toggleSidebar} className="p-1 hover:bg-blue-dark rounded transition-colors">
            <span className="text-xl">☰</span>
        </button>
        </div>

        <PDASidebar isOpen={isOpen} onClose={closeSidebar} onMenuClick={onMenuClick} />
</>
    );
    };

    export default PDAHeader;
